import script from "./multi-factor-auth-faq-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./multi-factor-auth-faq-modal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__